var render = function render(){var _vm=this,_c=_vm._self._c;return _c('payment-template',[_c('base-header',{attrs:{"slot":"header","title":_vm.$t('content.returned.title'),"language":_vm.getLanguage},slot:"header"}),_c('access-denied',{attrs:{"slot":"content","title":_vm.$t('content.returned.message')},slot:"content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }